
$(document).ready(function() {
  $('.tab_cat_title .dib').click(function(e) {
    e.preventDefault();
    var getIndex = $(this).index();
    if(getIndex == 0) {
      $('#shopify-section-featured_collection_KxPmW8').hide();
      $('#shopify-section-featured_collection_wCQBAf').hide();
      $('#shopify-section-featured_collection_VDnymE').hide();
      $('#shopify-section-featured_collection_KxPmW8').show();
    } else if(getIndex == 1) {
      $('#shopify-section-featured_collection_KxPmW8').hide();
      $('#shopify-section-featured_collection_wCQBAf').hide();
      $('#shopify-section-featured_collection_VDnymE').hide();
      $('#shopify-section-featured_collection_wCQBAf').show();
    } else if(getIndex == 2) {
      $('#shopify-section-featured_collection_KxPmW8').hide();
      $('#shopify-section-featured_collection_wCQBAf').hide();
      $('#shopify-section-featured_collection_VDnymE').hide();
      $('#shopify-section-featured_collection_VDnymE').show();
    }
  });
  $('.tab_cat_title .dib')[0].click();
});